<template>
  <v-overlay :value="show">
    <div class="content">
      <div class="close" @click="closePlayer">X</div>
      <iframe
        :src="`https://www.youtube.com/embed/${id}`"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </v-overlay>
</template>

<script>
export default {
  props: ["show", "closePlayer", "id"],
};
</script>

<style lang="scss" scoped>
.content {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  iframe {
    width: 60%;
    height: 70vh;

    @include phone {
      width: 80%;
      height: 20vh;
    }
  }
  .close {
    color: white;
    font-size: 2rem;
    position: absolute;
    top: 2rem;
    right: 2rem;
    cursor: pointer;
  }
}
</style>